<script>
    export default {
        props: {
            data: Object,
            withCols: {
                type: Boolean,
                default: false
            },
            lightboxPrefix: {
                type: String,
                default: 'editValue'
            }
        },
        data() {
            return {
                attribute: this.data,
                storeValueData: {},
                updateValueData: {},
            }
        },
        computed: {
            position() {
                return _.toArray(this.attribute.values).length;
            },
            options() {
                return _.orderBy(this.attribute.options, 'text', 'asc');
            },
            isLocked() {
                return this.attribute.readonly === 1;
            },
            contextValues() {
                return this.attribute.context ? _.orderBy(this.attribute.context_values, 'context_label', 'asc') : null;
            },
            hasContext() {
                return !!this.attribute.context;
            },
            headline() {
                if (this.attribute.context) {
                    return this.attribute.name + ': <strong>' + this.attribute.context.context_label + '</strong>';
                }

                return '<strong>' + this.attribute.name + '</strong>';
            },
            canAddAnotherValue() {
                if (this.attribute.max_positions && this.attribute.values.length < this.attribute.max_positions) {
                    return true;
                }

                if (this.attribute.values.length === 0) {
                    return true;
                }

                return this.hasContext;
            }
        },
        methods: {
            storeValue() {
                var storeData = _.merge({
                    'related_model_type': this.attribute.related_model_type,
                    'related_model_id': this.attribute.related_model_id,
                    'text_attribute_id': this.attribute.text_attribute_id,
                    'text_attribute_context_id': this.attribute.context ? this.attribute.context.id : null
                }, this.storeValueData);

                axios.post(window.Scoop.baseUrl + '/edito/storeValue', storeData).then((response) => {
                    console.log('Storing attribute', storeData);

                    $('#'+this.lightboxId(this.storeValueData.id)).modal('hide');

                    toastr.success('Attribut wurde gespeichert', this.attribute.name);

                    this.attribute = response.data;
                    this.storeValueData = {};
                }).catch(function (error) {
                    toastr.error(error.response.data.message, error.response.statusText);
                });
            },
            updateValue(clearPayload = true, refreshAttribute = true) {
                console.log('Updating attribute', this.updateValueData);

                axios.post(window.Scoop.baseUrl + '/edito/updateValue', this.updateValueData).then((response) => {
                    console.log('#'+this.lightboxId(this.updateValueData.id));
                    $('#'+this.lightboxId(this.updateValueData.id)).modal('hide');

                    toastr.success('Attribut wurde aktualisiert', this.attribute.name);

                    if (refreshAttribute){
                        this.attribute = response.data;
                    }

                    if (clearPayload) {
                        this.updateValueData = {};
                    }

                }).catch(function (error) {
                    toastr.error(error.response.data.message, error.response.statusText);
                });
            },
            deleteValue(id) {
                axios.delete(window.Scoop.baseUrl + '/edito/deleteValue/' + id).then((response) => {
                    console.log('Deleting attribute', id);

                    $('#'+this.lightboxId(id)).modal('hide');

                    toastr.success('Wert wurde gelöscht');

                    this.attribute.values = _.reject(this.attribute.values, function (value) {
                        return value.id === id;
                    });
                }).catch(function (error) {
                    toastr.error(error.response.data.message, error.response.statusText);
                });
            },
            selectToUpdate(value) {
                this.updateValueData = $.extend(true, {}, value);
            },
            lightboxId(id) {
                return this.lightboxPrefix + id;
            }
        }
    }
</script>